import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../../providers/root-store-provider';

export const HamburgerMenu: React.FC = observer(() => {
    const { themeStore } = useRootStore();

    return (
        <div
            className="relative flex h-[3rem] w-[3rem] cursor-pointer items-center justify-center rounded-full bg-brand-secondary vl:hidden"
            onClick={() => {
                themeStore.toggleMobileNavigationDisplay();
                themeStore.hideMobilePortfolioNavigation();
            }}
        >
            <div className="absolute inset-0 m-auto h-[0.8rem] w-[1.6rem]">
                <div
                    className={`absolute block h-[0.2rem] w-[1.6rem] bg-text-inverse transition-all ${
                        themeStore.mobileNavigationDisplay ? 'left-0 top-[0.3rem] rotate-45' : 'top-0'
                    }`}
                />
                <div
                    className={`absolute block h-[0.2rem] w-[1.6rem] bg-text-inverse transition-all ${
                        themeStore.mobileNavigationDisplay ? 'bottom-[0.3rem] left-0 -rotate-45' : 'bottom-0'
                    }`}
                />
            </div>
        </div>
    );
});
